import {
	amountFormatter,
	calculateNHFAmount,
	calculateWHTAmount,
	calculatePAYEAmount,
	calculatePensionAmount,
	calculateNetAmount,
} from '../../utils/utils';
import {
	MimaButton,
	MimaInput,
	IconButton,
	MimaText,
	ReceiptCheckBox as RCB,
	Modal,
	MimaTextArea,
	MimaDropdown,
} from '../../components';
import styles from '../../assets/styles/Employees/Employees.module.scss';
import { Formik, FieldArray, Field } from 'formik';
import { employeeStore } from '../../stores';
import { toJS } from 'mobx';
import React from 'react';

const FieldInput = ({ field, ...props }) => {
	return <MimaInput {...field} {...props} />;
};

const FieldSelect = ({ field, ...props }) => {
	return <MimaDropdown {...field} {...props} />;
};

const ViewGroups = ({
	closeModal,
	loading,
	validationSchema,
	onSubmit,
	totalExtra,
	addFundList,
	createGroup,
	addDeductionList,
	showCreateGroup,
	groupDetails,
	groupNames,
	goBack,
}) => {
	return (
		<Modal closeModal={closeModal} goBack={goBack}>
			<>
				{!createGroup && !groupDetails && (
					<>
						<MimaButton title="Create Group" onClick={showCreateGroup} />
						<div className={styles.employee__list}>
							{toJS(groupNames).map((group, i) => (
								<div key={i}>
									<li
										onClick={() => {
											employeeStore.setSelectedEmployeeGroup(group);
											showCreateGroup();
										}}>
										{group.name}
									</li>
									<div className={styles.employee__list_line}></div>
								</div>
							))}
						</div>
					</>
				)}
				{createGroup && (
					<>
						<MimaText
							variant="subtitle"
							align="center"
							color="var(--color-primary)"
							mb={2}>
							Create Groups
						</MimaText>
						<Formik
							initialValues={{
								name: employeeStore?.selectedEmployeeGroup?.name || '',
								description:
									employeeStore?.selectedEmployeeGroup?.description || '',
								department:
									employeeStore?.selectedEmployeeGroup?.department?._id || '',
								departmentName:
									employeeStore?.selectedEmployeeGroup?.department?._id || '',
								grossPay: employeeStore?.selectedEmployeeGroup?.grossPay || 0,

								jobTitle: employeeStore?.selectedEmployeeGroup?.jobTitle || '',
								employmentType:
									employeeStore?.selectedEmployeeGroup?.employmentType || '',
								paymentType:
									employeeStore?.selectedEmployeeGroup?.paymentType || '',
								settlementCycle:
									employeeStore?.selectedEmployeeGroup?.settlementCycle || '',
								// deductions: employeeStore?.selectedEmployeeGroup
								// 	?.deductions || {
								// 	tax: false,
								// 	pension: false,
								// 	nhf: false,
								// 	wht: false,
								// },
							}}
							validationSchema={validationSchema}
							onSubmit={onSubmit}>
							{({
								handleChange,
								handleBlur,
								handleSubmit,
								setFieldValue,
								values,
								errors,
								touched,
							}) => (
								<div style={{width: "38rem"}}>
									<div >
										<MimaInput
											type="text"
											labelTitle="Group Title"
											id="name"
											placeholder="Group Title"
											name="name"
											mt={2}
											mb={2}
											value={values.name}
											onChange={handleChange}
											onBlur={handleBlur}
											error={errors.name}
											touched={touched.name}
										/>
										<MimaInput
											type="text"
											labelTitle="Enter Job Title, if they all share the same job title"
											id="jobTitle"
											placeholder="Job Title"
											name="jobTitle"
											mt={2}
											mb={2}
											value={values.jobTitle}
											onChange={handleChange}
											onBlur={handleBlur}
											touched={touched.jobTitle}
										/>
										<MimaTextArea
											type="text"
											labelTitle="Description"
											id="description"
											placeholder="Description"
											name="description"
											mt={2}
											mb={2}
											value={values.description}
											onChange={handleChange}
											onBlur={handleBlur}
											touched={touched.description}
										/>

										<MimaDropdown
											labelTitle="Select Department, if they are in the same department"
											placeholder={
												employeeStore?.selectedEmployeeGroup?.department?.name || "Select Department"
											}
											name="department"
											currentValue={values.departmentName}
											value={values.departmentName}
											id="department"
											onChange={data => {
												setFieldValue('department', data.key);
												setFieldValue('departmentName', data.value);
											}}
											data={employeeStore.mapDepartments}
											touched={touched.department}
										/>
										<div className={styles.checks_group}>
											<MimaText ml={2} mb={2} variant="small">
												Employment Type
											</MimaText>

											<div className={styles.checks}>
												<RCB
													title="FULLTIME"
													id="FULLTIME"
													name="employmentType"
													onChange={() => {
														setFieldValue('employmentType', 'FULLTIME');
													}}
													checked={values.employmentType === 'FULLTIME'}
													value="FULLTIME"
												/>
												<RCB
													title="CONTRACT"
													name="employmentType"
													id="CONTRACT"
													onChange={() => {
														setFieldValue('employmentType', 'CONTRACT');
													}}
													checked={values.employmentType === 'CONTRACT'}
													value="CONTRACT"
												/>
											</div>
											{errors.employmentType ? (
												<div className={styles.error}>
													{''}
													{touched.employmentType && errors.employmentType}
													{''}
												</div>
											) : null}
										</div>
										<div className={styles.checks_group}>
												<MimaText ml={2} mb={2} variant="small">
													Payment Cycle
												</MimaText>

												<div className={styles.checks}>
													<RCB
														title="WEEKLY"
														id="WEEKLY"
														name="settlementCycle"
														onChange={() => {
															setFieldValue('settlementCycle', 'WEEKLY');
														}}
														checked={values.settlementCycle === 'WEEKLY'}
														value="WEEKLY"
													/>
													<RCB
														title="BI-WEEKLY"
														id="BI-WEEKLY"
														name="settlementCycle"
														onChange={() => {
															setFieldValue('settlementCycle', 'BI-WEEKLY');
														}}
														checked={values.settlementCycle === 'BI-WEEKLY'}
														value="BI-WEEKLY"
													/>
													<RCB
														title="MONTHLY"
														id="MONTHLY"
														name="settlementCycle"
														onChange={() => {
															setFieldValue('settlementCycle', 'MONTHLY');
														}}
														checked={values.settlementCycle === 'MONTHLY'}
														value="MONTHLY"
													/>
												</div>

												{errors.settlementCycle ? (
													<div className={styles.error}>
														{''}
														{touched.settlementCycle && errors.settlementCycle}
														{''}
													</div>
												) : null}
											</div>
											<MimaInput
												type="number"
												labelTitle="Do they share a common Monthly Gross Salary? if yes enter the gross salary"
												placeholder="Enter Gross salary Per month, if they share the same Monthly Gross Salary"
												name="grossPay"
												mb={2}
												min={0}
												value={values.grossPay}
												onChange={handleChange}
												onBlur={handleBlur}
												touched={touched.grossPay}
											/>

										{/* {values.grossPay !== 0 && (
											<>
												<div className={styles.checks_group}>
													<MimaText
														mt={2}
														mb={2}
														align="center"
														color="var(--color-primary)"
														variant="bodyBold">
														Kindly select what you want to be deducted from the
														gross salary
													</MimaText>
													<div className={styles.checks}>
														{values.employmentType === 'FULLTIME' ? (
															<>
																<RCB
																	title="Paye Tax"
																	id="deductions.tax"
																	name="deductions.tax"
																	onChange={() => {
																		setFieldValue(
																			'deductions.tax',
																			!values.deductions?.tax
																		);
																	}}
																	checked={values.deductions?.tax}
																	value={true}
																/>

																<RCB
																	title="Pension"
																	name="deductions.pension"
																	onChange={() => {
																		setFieldValue(
																			'deductions.pension',
																			!values.deductions?.pension
																		);
																	}}
																	checked={values.deductions?.pension}
																	id="deductions.pension"
																	value={true}
																/>
																<RCB
																	title="NHF"
																	name="deductions.nhf"
																	onChange={() => {
																		setFieldValue(
																			'deductions.nhf',
																			!values.deductions?.nhf
																		);
																	}}
																	checked={values.deductions?.nhf}
																	id="deductions.nhf"
																	value={true}
																/>
															</>
														) : (
															<RCB
																title="WHT"
																name="deductions.wht"
																onChange={() => {
																	setFieldValue(
																		'deductions.wht',
																		!values.deductions?.wht
																	);
																}}
																checked={values.deductions?.wht}
																id="deductions.wht"
																value={true}
															/>
														)}
													</div>
													{values.deductions?.tax &&
														values.employmentType === 'FULLTIME' && (
															<MimaInput
																type="text"
																labelTitle="PAYE Tax Per month(Month)"
																disabled={true}
																name="taxAmount"
																mb={2}
																min={0}
																value={amountFormatter().format(
																	calculatePAYEAmount({
																		amount: values.grossPay,
																		quaterlyBonus: values.quaterlyBonus,
																		leaveAllowance: values.leaveAllowance,
																		thirtheenMonthBonus:
																			values.thirtheenMonthBonus,
																		chargedPension: values.deductions?.pension,
																		chargedNHF: values.deductions?.nhf,
																		performanceBonus: values.performanceBonus,
																	})
																)}
																onChange={handleChange}
																onBlur={handleBlur}
															/>
														)}
													{values.deductions?.wht &&
														values.employmentType === 'CONTRACT' && (
															<MimaInput
																type="text"
																labelTitle="WHT Per month(Month)"
																disabled={true}
																name="whtAmount"
																mb={2}
																min={0}
																value={amountFormatter().format(
																	calculateWHTAmount(values.grossPay || 0)
																)}
																onChange={handleChange}
																onBlur={handleBlur}
															/>
														)}
													{values.deductions?.pension &&
														values.employmentType === 'FULLTIME' && (
															<MimaInput
																type="text"
																labelTitle="Pension Per month(Month)"
																disabled={true}
																name="pensionAmount"
																mb={2}
																min={0}
																value={amountFormatter().format(
																	calculatePensionAmount(values.grossPay || 0)
																)}
																onChange={handleChange}
																onBlur={handleBlur}
															/>
														)}
													{values.deductions?.nhf &&
														values.employmentType === 'FULLTIME' && (
															<MimaInput
																type="text"
																labelTitle="NHF Per month(Month)"
																disabled={true}
																name="nhfAmount"
																mb={2}
																min={0}
																value={amountFormatter().format(
																	calculateNHFAmount(values.grossPay)
																)}
																onChange={handleChange}
																onBlur={handleBlur}
															/>
														)}
												</div>

											</>
										)} */}
									</div>
									<MimaButton
										title={`Expected Monthly Net Pay: ${calculateNetAmount(
											values
										)}`}
										variant="text"
										type="button"
									/>
									<MimaButton
										title="Submit"
										onClick={handleSubmit}
										type="submit"
										loading={loading}
										mt={2}
									/>
								</div>
							)}
						</Formik>
					</>
				)}
			</>
		</Modal>
	);
};

export default ViewGroups;
